import * as actionTypes from "../actionTypes";

export function setSolutionsCache(cache) {
  return { type: actionTypes.SET_SOLUTIONSCACHE, data: cache };
}

export function clearSolutionsCache() {
  return { type: actionTypes.CLEAR_SOLUTIONSCACHE };
}
